<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
            <div class="form-group col-xs-6">
                <select v-model="paramsOperator" class="form-control">
                    <option value=">=">Greater Than or Equal To</option>
                    <option value=">">Greater Than</option>
                    <option value="<">Less Than</option>
                    <option value="<=">Less Than or Equal To</option>
                </select>
            </div>
            <div class="form-group col-xs-6">
                <input type="number" v-model="paramsValue" class="form-control">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['params'],
        name: 'SearchCompareNumber',
        data () {
            return {
            }
        },
        computed: {
            paramsValue: {
                get () {
                    return this.params !== null ? this.params.value || null : null
                },
                set (newValue) {
                    this.$emit('update:params', {
                        value: newValue,
                        operator: this.params.operator
                    })
                }
            },
            paramsOperator: {
                get () {
                    return this.params !== null ? this.params.operator || null : null
                },
                set (newValue) {
                    this.$emit('update:params', {
                        value: this.params.value,
                        operator: newValue
                    })
                }
            }
        },
        methods: {},
        created () {
            if (this.params === null) {
                this.$emit('update:params', {
                    value: '',
                    operator: '>='
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchCompareNumber.vue?e321b412